import { useEffect, useState } from "react";
import { motion, useReducedMotion } from "framer-motion";
import { getCertifications } from "@/lib/api";

const EASE = [0.22, 1, 0.36, 1];

export default function ComplianceWall() {
  const [items, setItems] = useState([]);
  const reduced = useReducedMotion();

  useEffect(() => {
    getCertifications().then(setItems).catch(() => {});
  }, []);

  if (!items.length) return null;

  return (
    <section
      id="compliance"
      data-testid="compliance-wall"
      className="relative py-24 md:py-28 border-t border-gold/10"
    >
      <div className="mx-auto max-w-[1440px] px-6 lg:px-10">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <div className="inline-flex items-center gap-3 mb-4">
            <span className="h-px w-6 bg-gold/50" />
            <span className="font-mono text-[10px] tracking-[0.34em] text-gold-body">
              COMPLIANCE & CERTIFICATIONS
            </span>
            <span className="h-px w-6 bg-gold/50" />
          </div>
          <h2
            className="font-display font-semibold leading-[1.05] tracking-[-0.02em] text-inkText-primary"
            style={{ fontSize: "clamp(1.75rem, 3vw, 2.5rem)" }}
          >
            Audited, aligned, and accountable.
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
          {items.map((c, i) => (
            <motion.div
              key={c.name}
              initial={reduced ? false : { opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.55, ease: EASE, delay: i * 0.04 }}
              data-testid={`cert-badge-${c.name.replace(/\s+/g, "-").toLowerCase()}`}
              className="group flex flex-col items-center justify-center rounded-xl glass-panel px-4 py-6 text-center transition-[border-color,transform] duration-500 hover:border-gold hover:-translate-y-0.5"
            >
              <div className="h-12 w-12 rounded-full border border-gold/30 bg-ink-panel/60 flex items-center justify-center mb-3 text-gold group-hover:text-gold-body transition-colors">
                <span className="font-mono text-xs tracking-wider">
                  {c.name.split(" ")[0].slice(0, 4).toUpperCase()}
                </span>
              </div>
              <div className="font-display text-sm text-inkText-primary leading-tight">
                {c.name}
              </div>
              <div className="font-mono text-[10px] tracking-widest text-inkText-muted mt-1.5">
                {c.issuer.toUpperCase()}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
